import axios from "axios";
/**
 *
 * @param {String} baseRestUrl LFC-backend URL, differs if running in dev/test or live.
 * @param {String} marketCode In text format: SE-SKBV, NO-BYME etc
 * @param {String} contextId LFC Product ID, for example TW3204DP. Not sure why it's called contextId in the api call.
 * @param {String} namedConfigCode Currently it will always be "DEFAULT".
 * @param {Boolean} useCache Currently it will always be true.
 * @param {Function} onSuccess Function that handles data on success.
 * @param {Function} onError Function that handles eventual errors.
 */
export default function getProductPreset(
  baseRestUrl,
  marketCode,
  contextId,
  namedConfigCode = "DEFAULT",
  useCache = true,
  onSuccess,
  onError
) {
  const url = `${baseRestUrl}/presetlookup/preset?marketCode=${marketCode}&useCache=${useCache}`;
  const body = {
    contextId: contextId,
    namedConfigCode: namedConfigCode,
  };

  axios
    .post(url, body)
    .then(response => {
      const { status, data } = response;
      if (status === 200 && data.chosenValues) {
        onSuccess(data.chosenValues);
      } else {
        onError({
          errorMessage: "Response status is not 200 or choseValues is missing",
          response,
        });
      }
    })
    .catch(error => {
      console.error(JSON.stringify(error));
    });
}
